/*
 * Copyright (c) 2024 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import { PackageDtoModel, PackageSplitModel, PackageVoModel } from '@well/delivery-libs/packages/domain';

export class PackageMapper {
  static mapPackageVoToPackageDtoList(packageVos: PackageVoModel[]): PackageDtoModel[] {
    return packageVos.map((packageVos) => PackageMapper.mapPackageVoToPackageDto(packageVos));
  }

  static mapPackageVoToPackageDto(packageVo: PackageVoModel): PackageDtoModel {
    const packageDTO = new PackageDtoModel();
    packageDTO.uuid = packageVo.uuid;
    packageDTO.id = packageVo.id;
    packageDTO.shipmentBaseUuid = packageVo.shipmentUuid;
    packageDTO.standardPackageDimensionName = packageVo.standardPackageDimensionName;
    packageDTO.standardPackageDimensionUuid = packageVo.standardPackageDimensionUuid;
    packageDTO.height = packageVo.height;
    packageDTO.width = packageVo.width;
    packageDTO.length = packageVo.length;
    packageDTO.weight = packageVo.weight;
    packageDTO.pieces = packageVo.count;
    packageDTO.type = packageVo.type;
    packageDTO.tags = packageVo.tags || [];

    return packageDTO;
  }

  static mapPackageVoToPackageSplit(packageVo: PackageVoModel): PackageSplitModel {
    return {
      uuid: packageVo.uuid,
      id: packageVo.id,
      shipmentBaseUuid: packageVo.shipmentUuid,
      standardPackageDimensionUuid: packageVo.standardPackageDimensionUuid,
      height: packageVo.height,
      width: packageVo.width,
      length: packageVo.length,
      weight: packageVo.weight,
      pieces: packageVo.count,
      type: packageVo.type,
      tags: packageVo.tags || [],
      packageStatusType: packageVo.packageStatusType,
    };
  }

  static mapPackageDtoToPackageVo(packageDto: PackageDtoModel): PackageVoModel {
    const packageVo = new PackageVoModel();
    packageVo.uuid = packageDto.uuid;
    packageVo.id = packageDto.id;
    packageVo.shipmentUuid = packageDto.shipmentBaseUuid;
    packageVo.standardPackageDimensionName = packageDto.standardPackageDimensionName;
    packageVo.standardPackageDimensionUuid = packageDto.standardPackageDimensionUuid;
    packageVo.height = packageDto.height;
    packageVo.width = packageDto.width;
    packageVo.length = packageDto.length;
    packageVo.weight = packageDto.weight;
    packageVo.count = packageDto.pieces;
    packageVo.type = packageDto.type;
    packageVo.tags = packageDto.tags || [];

    return packageVo;
  }

  static mapPackageDtoListToPackageVoList(packageDtos: PackageDtoModel[]): PackageVoModel[] {
    return packageDtos.map((packageDto) => PackageMapper.mapPackageDtoToPackageVo(packageDto));
  }
}
